import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

const columnLabels = {
  ranking: {
    name: 'Ranking',
    isStatic: false
  },
  market_code_type: {
    name: 'Market Code Type',
    isStatic: false
  },
  market_code: {
    name: 'Market code',
    isStatic: false
  },
  aggregated_value_amount: {
    name: 'Aggregated value',
    isStatic: false
  }
};

export function MostImportPortfolioAIF001({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.AIFM_FIVE_PRINCIPAL_MARKET,
    onChangeFund,
    schema: schema.AIFM_FIVE_PRINCIPAL_MARKET,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.AIFM_FIVE_PRINCIPAL_MARKET?.field_names || [],
    order: 27,
    tableName: 'AIFM_FIVE_PRINCIPAL_MARKET',
    columnLables: columnLabels,
    isMultiFunds,
    funds
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.AIFM_FIVE_PRINCIPAL_MARKET?.field_names?.length === 0;

  const errors = funds[currentDataKey]?.fund_data?.AIFM_FIVE_PRINCIPAL_MARKET?.find(
    item => item?.errors?.general
  )?.errors?.general as any;

  return (
    <>
      <Errors id="fca-reporttables-most-important-portfolio-aif001-errors">
        {isRequiredTable && (
          <li id="fca-reporttables-most-important-portfolio-aif001-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map(item => (
          <li
            key={item.msg}
            id={`fca-reporttables-most-important-portfolio-aif001-error-${idCreator(item.msg)}`}
          >
            {item.msg}
          </li>
        ))}
      </Errors>

      <StyledTables id="fca-reporttables-most-important-portfolio-aif001-group">
        {tables.map((rows, index) => (
          <Table
            id={`fca-reporttables-most-important-portfolio-aif001-table-${index + 1}`}
            key={index + 'PRINCIPAL_EXPOSURES'}
            handleChanges={onChange}
            columns={columns}
            rows={rows}
            stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
          />
        ))}
      </StyledTables>
    </>
  );
}
